import { GraphicIdentity } from '../ts/components/GraphicIdentity';
import { Analytics } from '../../views/ts/components/Analytics';
import { CookiesConsent } from '../../views/twig/components/CookiesConsent';
import { Carousel } from '../../views/ts/components/Carousel';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { AnimatedLogo } from '../../views/twig/components/AnimatedLogo';
import { FunnyCursor } from '../../views/twig/components/FunnyCursor';
import { Menu } from '../../views/twig/components/Menu';
import { FrontPage } from '../twig/pages/front-page';
import { ComingSoon } from '../twig/pages/template-coming-soon/';
import { SingleProduct } from '../twig/pages/single-product/';
import { TemplateBooks } from '../twig/pages/template-books/';
import { Sections } from '../twig/components/Sections';
import { Shop } from '../twig/pages/shop';
(new GraphicIdentity()).init();
(new Analytics()).init();
(new Carousel()).init();
(new LazyLoader()).init();
(new AnimatedLogo()).init();
(new Menu()).init();
(new FunnyCursor()).init();
(new FrontPage()).init();
(new ComingSoon()).init();
(new SingleProduct()).init();
(new TemplateBooks()).init();
(new Sections()).init();
(new Shop()).init();
// Always at the end
(new CookiesConsent()).init();
